import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import type { ConversationProfile } from '@app/modules/messaging/models/conversation-profile.model'
import type { ButtonVariant } from '@app/modules/ui/components/button/button.model'
import { UIModule } from '@app/modules/ui/ui.module'
import { Confirmable } from '@ui/models/confirmable'

@Component({
  selector: 'sb-boost-message-modal',
  templateUrl: './boost-message-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoostMessageModalComponent extends Confirmable {
  @Input({ required: true }) profile!: ConversationProfile
  @Input({ required: true }) headlineCopy!: string
  @Input({ required: true }) buttonVariant!: ButtonVariant
  @Input({ required: true }) buttonCopy!: string
}
